import React from "react";
import {
  EXAM_PAPER_TYPE_READING_WRITING,
  EXAM_PAPER_TYPE_MATH,
} from "@/constants/exam";
import HighlightableContent from "./HighlightableContent";
import MathShortAnswerDirections from "./MathShortAnswerDirections";

interface ExamPassageProps {
  passage: string;
  subject?: string;
  examType?: string;
  answer_type?: string;
  examProgressId?: string;
  questionId?: string;
  passageType?: string;
  onSaveHighlight?: (
    contentType: "passage" | "question",
    newContent: string
  ) => void;
}

const ExamPassage: React.FC<ExamPassageProps> = ({
  passage,
  subject,
  examType,
  answer_type,
  passageType,
  onSaveHighlight,
}) => {
  // Check if passage should be hidden based on passage_type
  if (passageType === "none") {
    // For SAT Math with short_answer, show directions
    if (examType === "SAT" && subject === EXAM_PAPER_TYPE_MATH && answer_type === "short_answer") {
      return <MathShortAnswerDirections />;
    }
    // Otherwise, hide passage completely
    return null;
  }

  // Legacy logic: SAT Math일 때는 passage를 보여주지 않음
  if (examType === "SAT" && subject === EXAM_PAPER_TYPE_MATH) {
    // Math 타입이고 short_answer일 때
    if (answer_type === "short_answer") {
      return <MathShortAnswerDirections />;
    }
    // 그 외의 Math 경우
    return null;
  }

  // Show passage for all other cases
  return (
    <div className="w-1/2 h-full overflow-auto p-8 bg-white border-r border-gray-200">
      <HighlightableContent
        content={passage}
        contentType="passage"
        onSaveHighlight={onSaveHighlight}
        className="max-w-[650px] w-full"
      />
    </div>
  );
};

export default ExamPassage;
